// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Archive } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconArchive(props: any) {
    return <IconBase icon={Archive} {...props} />
  }

  export default IconArchive
  